import React from 'react';
import { Field } from 'formik';
import PreferencesTitleSection from '../icons/PreferencesTitleSection';
import OptSwitch from '../OptSwitch';
import ErrorMessageRenderer from '../notifications/ErrorMessageRenderer';
import FieldNote from '../../containers/preferences/PreferencesFieldNoteContainer';
import withTranslate from '../withTranslate';
import ErrorMessageList from '../notifications/ErrorMessageList';
import { EmailStatus } from '../../interfaces/EmailStatus';
import { preferenceErrorMessages } from '../notifications/preferenceErrorMessages';

export interface EmailFieldProps {
  values: {
    emailOptIn: boolean;
    isValidEmail: boolean | null;
    email?: string;
  };
  setValues: (o: object) => void;
  _t: (str: string) => Array<string | JSX.Element>;
  user: {
    email: string;
  };
  errors: {
    email?: string[];
  };
  touched: {
    email: any;
  };
  machine: any;
}

export const EmailField = ({
  values,
  setValues,
  _t,
  user,
  errors,
  touched,
}: EmailFieldProps) => {
  const { UNKNOWN, VALID, INVALID } = EmailStatus;
  let emailStatus: EmailStatus;

  if (values.isValidEmail === null) {
    emailStatus = UNKNOWN;
  } else {
    emailStatus = values.isValidEmail ? VALID : INVALID;
  }

  // @ts-ignore
  return (
    <fieldset className="preference-section email-section">
      <legend className="screen-reader">{_t('Opt-In Email')}</legend>
      <div className="preference-section-header">
        <PreferencesTitleSection
          type={'email'}
          title={_t('Opt-In Email') as string[]}
        />
        <OptSwitch
          screenReaderPhrase={_t('Opt-In Email')}
          optedIn={values.emailOptIn}
          onClick={() => {
            setValues({
              ...values,
              emailOptIn: !values.emailOptIn,
            });
          }}
        />
      </div>

      <div className="input-section">
        <label
          htmlFor={'email'}
          className="preference-label email-preference-label"
        >
          {_t('Email')}
        </label>
        <div>
          <Field
            className="preference-input"
            id={'email'}
            name={'email'}
            placeholder={_t('Example: test@sample.com')}
            autoComplete="email"
            onChange={(e: any) => {
              setValues({
                ...values,
                email: e.target.value,
                emailOptIn: true,
                isValidEmail:
                  user.email === '' || user.email !== e.target.value,
              });
            }}
            aria-describedby={'email-error-list email-error'}
          />
          <button
            className="clear-field"
            type="button"
            aria-label={_t('Clear email field contents').join('')}
            onClick={() =>
              setValues({
                ...values,
                email: '',
                emailOptIn: false,
                isValidEmail: true,
              })
            }
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
      <div className={''} aria-live="polite" aria-atomic="true">
        <div id={'email-error-list'}>
          {touched.email && (
            <ErrorMessageList errors={errors.email} field={'email'} limit={3} />
          )}
        </div>
        <div id={'email-error'}>
          {emailStatus === INVALID && !errors.email && (
            <ErrorMessageRenderer
              // @ts-ignore
              error={preferenceErrorMessages.email.invalidEmail}
              field={'email'}
              invalidEmail
            />
          )}
        </div>
        {!(errors.email && touched.email) && emailStatus !== INVALID && (
          <FieldNote
            field={'email'}
            optStatus={values.emailOptIn}
            replacements={{}}
          />
        )}
      </div>
    </fieldset>
  );
};

export default withTranslate(EmailField);
